export default function changeLang() {
    const langButtons = document.querySelectorAll(".lang-drop");
    const langFunctionElement = document.getElementById("langFunction");
    const routeCurrentElement = document.getElementById("routeCurrent");

    if (langButtons.length > 0 && langFunctionElement && routeCurrentElement) {
        langButtons.forEach(button => {
            button.addEventListener("click", function (e) {
                e.preventDefault(); // Impede o navegador de seguir o href="#"
                
                const lang = this.getAttribute("lang");
                const url = langFunctionElement.value;

                fetch(url, {
                    method: "POST",
                    headers: {
                        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ lang: lang }),
                })
                .then(async (response) => {
                    if (response.ok) return response.json();
                    if (response.status === 419) location.reload();
                })
                .then((data) => {
                    if (data && data.status) {
                        window.location.replace(routeCurrentElement.value);
                    }
                })
                .catch((error) => console.error("Erro:", error));
            });
        });
    }
}